import {
  Box,
  Button,
  CircularProgress,
} from "@mui/material";

import VerificationCodeField from "./VerificationCodeField";

export default function AuthCodeVerificationForm({
  actionLabel = "Confirmar",
  autoFocus = false,
  children,
  code,
  disabled = false,
  error = false,
  helperText,
  name = "verificationCode",
  onCodeChange,
}) {
  return (
    <>
      <VerificationCodeField
        label="Código para autenticação"
        required
        name={name}
        value={code}
        onChange={onCodeChange}
        autoFocus={autoFocus}
        error={error}
        helperText={helperText}
        disabled={disabled}
      />

      <Button type="submit" variant="contained" fullWidth disabled={disabled}>
        {disabled ? <CircularProgress color="inherit" size={18} /> : actionLabel}
      </Button>

      {children ? (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            mt: 1.5,
          }}
        >
          {children}
        </Box>
      ) : null}
    </>
  );
}
